const swiftCode = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value);
};

export default swiftCode;
